.sortDirectionButtonStyle {
  cursor: pointer;
  padding: 3px;
  display: inline-grid;
  place-content: center;
  background: transparent;
  margin-top: 10px;
  border-radius: 4px;
}

.sortDirectionButtonStyle:hover {
  background-color: var(--tractie-color-background-hover);
}
